//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { parseErrorMessage } from '~/utils/error'
import { getUtmAndCampaignByAppendingToData } from '~/utils/utm'

const PARTNER_UYK = 'uyk'
const PARTNER_SV = 'sv'
const PARTNER_PROSOOLO = 'prosoolo'
const PARTNER_LOUNEA = 'lounea'

const TYPE_COMPANY = 'company'
const TYPE_CLIENT = 'client'

const PARTNER_IDS = {
  [PARTNER_PROSOOLO]: 'PROSOOLO2019',
  [PARTNER_SV]: 'ale2025'
}

export default {
  props: {
    variant: {
      type: String,
      default: 'gray'
    },
    types: {
      type: Array,
      required: false,
      default: () => [TYPE_COMPANY, TYPE_CLIENT]
    },
    partner: {
      type: String,
      required: true
    },
    submitText: {
      type: String,
      required: false,
      default: 'Rekisteröidy'
    }
  },
  data () {
    return {
      PARTNER_UYK,
      PARTNER_SV,
      PARTNER_PROSOOLO,
      PARTNER_LOUNEA,

      TYPE_COMPANY,

      type: this.types[0],
      partnerId: '',
      firstName: '',
      lastName: '',
      email: '',
      companyName: '',
      companyIdent: '',

      error: '',
      loading: false,
    }
  },
  computed: {
    computedTypes () {
      return (this.types || []).map((type) => {
        return {
          value: type,
          title: type === 'client' ? this.$t('registrationForm.client') : this.$t('registrationForm.company')
        }
      }).filter((type) => {
        // Do not allow client registration in Sweden
        if (type.value === TYPE_CLIENT && this.$country.is(this.$country.SWEDEN)) {
          return false
        }

        return true
      })
    },
    partnerIdLabel () {
      switch (this.partner) {
        case PARTNER_PROSOOLO:
          return 'Kampanjakoodi'
        case PARTNER_SV:
          return 'Jäsenetukoodi'
      }

      return null
    },
    inputClass () {
      if (this.variant === 'white') {
        return '!tw-bg-white !tw-border-gray-300 !tw-border'
      }

      return null
    }
  },
  methods: {
    companyUpdated (company) {
      this.companyName = company.name
      this.companyIdent = company.ident
    },
    async submit () {
      if (this.loading) {
        return
      }

      // Validate partnerId
      const correctId = PARTNER_IDS[this.partner]
      if (correctId) {
        if (this.partnerId !== correctId) {
          this.error = `Virheellinen ${this.partnerIdLabel.toLowerCase()}`
          return
        }
      }

      this.loading = true

      try {
        const data = {
          email: this.email,
          first_name: this.firstName,
          last_name: this.lastName,
          workspace: {
            country: this.$country.current.countryCode
          }
        }

        if (this.type === TYPE_COMPANY) {
          data.workspace.name = this.companyName
          data.workspace.company_name = this.companyName
          data.workspace.company_ident = this.companyIdent
        } else {
          data.workspace.name = `${this.firstName} ${this.lastName}`
        }

        if (this.partner) {
          data.workspace.partner = this.partner

          // Give free document to Lounea customers
          if (this.partner === PARTNER_LOUNEA) {
            data.workspace.coupon = 'PARTNER_FREE_CONTRACT'
          }
        }

        getUtmAndCampaignByAppendingToData(this.$cookies, data.workspace)

        await this.$api.v2.register(data)

        this.$gtm.push({
          event: 'registerAccount',
          registerType: this.type
        })

        this.$ph.capture('workspace_created', {
          workspace_type: this.type === TYPE_COMPANY ? 'company' : 'consumer',
          workspace_country: data.workspace.country,
          workspace_partner: data.workspace.partner,
        })

        location.assign(this.$url.signUpVerify())
      } catch (e) {
        this.loading = false

        // eslint-disable-next-line no-console
        console.error(e)

        this.error = parseErrorMessage(e) || this.$t('unknownError')
      }
    }
  },
}
